var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNewOverviewInitialPath = function SvgNewOverviewInitialPath(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 617,
    height: 103,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#new-overview-initial-path_svg__a)",
    strokeWidth: 11,
    d: "m4.5 99 37-37.5H478l136-56"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "new-overview-initial-path_svg__a",
    x1: 589.5,
    x2: 42.5,
    y1: 60.998,
    y2: 59.498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333C3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8000"
  })))));
};
export { SvgNewOverviewInitialPath as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjE3IiBoZWlnaHQ9IjEwMyIgdmlld0JveD0iMCAwIDYxNyAxMDMiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik00LjUgOTlMNDEuNSA2MS41SDQ3OEw2MTQgNS41IiBzdHJva2U9InVybCgjcGFpbnQwX2xpbmVhcl8yMzgwXzIxMzUpIiBzdHJva2Utd2lkdGg9IjExIi8+CjxkZWZzPgo8bGluZWFyR3JhZGllbnQgaWQ9InBhaW50MF9saW5lYXJfMjM4MF8yMTM1IiB4MT0iNTg5LjUiIHkxPSI2MC45OTgiIHgyPSI0Mi40OTk2IiB5Mj0iNTkuNDk4MyIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiPgo8c3RvcCBzdG9wLWNvbG9yPSIjMzMzQzNFIi8+CjxzdG9wIG9mZnNldD0iMSIgc3RvcC1jb2xvcj0iI0ZGODAwMCIvPgo8L2xpbmVhckdyYWRpZW50Pgo8L2RlZnM+Cjwvc3ZnPgo=";